// Queries whose responses carry signed Mech Storage URLs (about 1h) must refresh well before those
// URLs expire, or images break on a long-open page.

/** Treat signed-URL data as stale after 10 minutes. */
export const SIGNED_URL_STALE_MS = 10 * 60_000;
/** Refetch at least this often while mounted (well under the ~59-minute expiry). */
export const SIGNED_URL_REFETCH_MS = 20 * 60_000;
/** Refetch this long before the earliest URL expires. */
const EXPIRY_MARGIN_MS = 5 * 60_000;
const MIN_REFETCH_MS = 30_000;

/**
 * Milliseconds until the next refetch: 5 minutes before the earliest `url_expires_at`, clamped to
 * between 30 seconds and the default refetch interval. Missing or invalid expiries use the default.
 */
export function signedUrlRefetchMs(expiries: ReadonlyArray<string | null | undefined>, now: number = Date.now()): number {
  const times = expiries.map((value) => (value ? Date.parse(value) : Number.NaN)).filter((value) => Number.isFinite(value));
  if (!times.length) return SIGNED_URL_REFETCH_MS;
  const due = Math.min(...times) - EXPIRY_MARGIN_MS - now;
  return Math.max(MIN_REFETCH_MS, Math.min(SIGNED_URL_REFETCH_MS, due));
}

/** react-query options shared by signed-URL queries (a refetchInterval is added per query). */
export const SIGNED_URL_QUERY_OPTIONS = {
  staleTime: SIGNED_URL_STALE_MS,
  refetchOnWindowFocus: true,
} as const;
